import { GET_SITEMAP } from '../constants';
import { defaultTransform } from '../utils';

export const loadSitemap = () => ({
  type: GET_SITEMAP,
  meta: {
    method: 'GET',
    endpoint: 'sitemap/',
    queryParams: {
      'no-paging': true
    }
  },
  i18n: {
    transform: defaultTransform('sitemap', 'title')
  }
});



// WEBPACK FOOTER //
// ./src/actions/sitemap.js